import { GridItemNormalizer } from '../types';

export default class UnitsObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_Units';
  }

  normalize(value: any) {
    return value?.units;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      units: '',
    };
  }
}
